'use client';

import {
  PointStatus,
  useAddressStore,
} from '@/entities/address/model/use-address-store';
import { useRouter } from '@/i18n/navigation';
import { useNavigationState } from '@/shared/store/use-navigation-state';
import { Button, Text } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import { FiSearch } from 'react-icons/fi';

const SearchButton = () => {
  const t = useTranslations('header');
  const router = useRouter();

  const { points, openMap } = useAddressStore();
  const { setRedirectTo } = useNavigationState();

  const hasActiveAddress = useMemo(() => {
    return points.some((point) => point.status === PointStatus.ACTIVE);
  }, [points]);

  const goToSearch = () => {
    if (!hasActiveAddress) {
      setRedirectTo('/search-product');
      openMap();
    } else {
      router.push('/search-product');
    }
  };

  return (
    <Button
      rounded="xl"
      variant="subtle"
      size="lg"
      gap="1"
      onClick={goToSearch}
    >
      <FiSearch />
      <Text>{t('search')}</Text>
    </Button>
  );
};

export default SearchButton;
